module.exports = "/_next/static/images/a322c394022cc728da6ac757c99e310d-card-lg@2x.jpg.webp";